export default __webpack_public_path__ + "static/media/trackinfo_racingline.f9a0aa06.png";